/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetConstructionProgressRequest,
  TGetConstructionProgressModel,
  IMappers,
  TGetConstructionProgressResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetConstructionProgressResponse } from '../../entities/get_construction_progress_page/GetConstructionProgressResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetConstructionProgressModel(
  parameters: IGetConstructionProgressRequest,
): TGetConstructionProgressModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'construction-progress',
    pathApi: '/v1/get-construction-progress/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetConstructionProgressOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetConstructionProgressRequest;
}

export async function fetchGetConstructionProgress<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetConstructionProgressOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetConstructionProgressResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetConstructionProgressModel(parameters),
    config,
  )) as FetchResponse<TGetConstructionProgressResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetConstructionProgressResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetConstructionProgressResponse>;
}
